export const PageSize = 10; // this value must keep same as the one defined in backend!
